// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__2b8IS"};